import { makeStyles } from '@material-ui/styles';

const styles = (theme) => ({
    card: {
        backgroundColor: '#ffffff',
        padding: 24,
        borderRadius: 4,
        boxShadow: theme.customShadows.widget,
        marginTop: 16,
        width: '100%',
    },

    actionsRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '12px',
    },

    // purchaseBtn: {

    // },

    // upgradeBtn: {

    // },

    cancelBtn: {
        // borderRadius: 9999,
        '&.MuiButton-outlined': {
            color: theme.palette.error.main,
            borderColor: theme.palette.error.main,
        },
        textTransform: 'uppercase',
        marginLeft: 'auto',
    },

    tooltip: {
        fontSize: 13,
    },
});

export default styles;
export const useStyles = makeStyles(styles);
